import type { AgentFinishResult } from '../../use-llm-agent';

// Successful-run completion broadcast for global UI side effects (e.g. the "Ready to view" toast).
// Runtime `onFinish` is a single slot per requestId that the last mounted hook instance wins, so a
// surface component cannot reliably own completion UI; subscribers here are independent of mounting.
//
// `pendingDocumentName` is passed only when fallback auto-naming was started for the run: it resolves
// with the document's latest name once naming settles, for subscribers that would rather wait for the
// real name than show `result.documentName`, the name at completion.
type AgentRunFinishListener = (result: AgentFinishResult, pendingDocumentName?: Promise<string | undefined>) => void;

const finishListeners = new Set<AgentRunFinishListener>();

export function subscribeAgentRunFinished(listener: AgentRunFinishListener): () => void {
  finishListeners.add(listener);
  return () => {
    finishListeners.delete(listener);
  };
}

export function emitAgentRunFinished(...args: Parameters<AgentRunFinishListener>): void {
  finishListeners.forEach((listener) => {
    try {
      listener(...args);
    } catch (error) {
      console.error('Agent run finish listener failed:', error);
    }
  });
}
